export const isTariffsEnabled = window.location.hostname !== 'app.nedvex.ru';



// WEBPACK FOOTER //
// ./src/components/Profile/helpers.js